const INVOICE_API_PATH = '/api/v1/efakturpdfs';

function siteBaseUrl() {
  return new URL(window.location.href).origin;
}

function buildDownloadUrl(
  companyId,
  vendorNpwp,
  invoiceNumber,
  origin
) {
  const paramsString = `companyId=${companyId}&vendorNpwp=${vendorNpwp}&invoiceNumber=${invoiceNumber}`;
  const url = new URL(INVOICE_API_PATH, origin);
  url.search = new URLSearchParams(paramsString).toString();
  return url.toString();
}

function buildDownloadUrlByNpwp(
  providerNpwp,
  vendorNpwp,
  invoiceNumber,
  origin
) {
  const paramsString = `providerNpwp=${providerNpwp}&vendorNpwp=${vendorNpwp}&invoiceNumber=${invoiceNumber}`;
  const url = new URL(INVOICE_API_PATH, origin);
  url.search = new URLSearchParams(paramsString).toString();
  return url.toString();
}

async function fetchInvoiceWrapper(fetchInvoice, url) {
  const response = await fetchInvoice(url);
  if (response.ok) {
    return response.blob();
  }
  return undefined;
}

async function handleDownload(fetchInvoice, saveInvoice, onPdfUndefined) {
  const invoiceWrapper = await fetchInvoice();
  if (invoiceWrapper === undefined) {
    onPdfUndefined();
  } else {
    saveInvoice(invoiceWrapper);
  }
}

function formatNpwp(value) {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
}

export {
  buildDownloadUrl,
  buildDownloadUrlByNpwp,
  fetchInvoiceWrapper,
  formatNpwp,
  handleDownload,
  siteBaseUrl
};
